export const reasonsForDelete = [
    {id: 1, text: 'Не подтверждено участие'},
    {id: 2, text: 'Отказ от участия'},
    {id: 3, text: 'Добавлена по ошибке'},
]
